import Input from './Input';
import PhoneInput from './PhoneInput';
import CouponInput from './CouponInput';

export { PhoneInput, CouponInput };
export default Input;

